import BaseTag, { TagProps as BaseTagProps } from 'antd/lib/tag'

export interface TagProps extends BaseTagProps {}

export const Tag = (props: TagProps): JSX.Element => (
  <>
    <BaseTag {...props} />
  </>
)
